<template>
  <div class="voice-to-text-container">
    <div class="trigger-area">
      <slot>
        <VoiceImage @click="toggleRecording" :isRecording="isRecording" :ws="ws" :isTodoBtn="isTodoBtn"
          :styleTemp="styleTemp" @hasMoved="setHasMoved" :currentTranscription="currentTranscription" />
      </slot>
    </div>
    <audio id="voicePlayer" ref="voicePlayer" controls style="display: none;"></audio>
  </div>
</template>

<script>
import CryptoJS from 'crypto-js'
import VoiceImage from './voiceImage.vue'
import EventBus from '@/components/schoolInstrument/mixins/EventBus';
import { getcommandlist, getoptionsbyvoice } from '@/port/admins/ai.js'
import { ElMessage } from 'element-plus';

// 定义静音超时时间 (3000毫秒 = 3秒)
const SILENCE_TIMEOUT = 3000;

export default {
  name: 'VoiceToText',
  props: {
    customdeskId: {
      type: String,
      default: ''
    },
    styleTemp: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      // 配置信息 - 需要用户填写自己的讯飞API信息
      config: {
        appId: '89046a2b', // 讯飞APP ID
        apiKey: 'fd322a5504f1ece38ee912e5fb91e891', // 讯飞API Key
        apiSecret: 'YTk2YzAwNTAxZmQ4YTc1MDQ2YWJjOTU1', // 讯飞API Secret
        language: 'zh_cn', // 默认中文 (讯飞参数)
      },

      // 状态变量
      isConnecting: false, // 是否正在连接（防止重复点击）
      isConnected: false, // WebSocket是否已连接
      isRecording: false, // 是否正在录音并传输数据
      isTodoBtn: false, // 是否正在处理 AI 语音命令 (防止重复提交)
      userMsg: null, // 用于存储 localStorage.getItem("userMsg") 的结果 (用户/学校信息)

      // Media Source Extension (MSE) 相关（用于播放 TTS 音频流）
      mediaSource: null, // MediaSource 对象
      sourceBuffer: null, // SourceBuffer 对象
      audioChunks: [], // 用于缓存 TTS 音频数据的数组

      // WebSocket相关 (讯飞 IAT)
      ws: null, // 讯飞 IAT 的 WebSocket 实例
      wsUrl: '', // 讯飞 IAT 的签名 URL

      // 音频录制相关 (Web Audio API)
      audioContext: null, // AudioContext 实例
      audioStream: null, // MediaStream 实例 (麦克风输入)
      analyser: null, // AudioAnalyserNode (用于语音可视化，传递给 VoiceImage 组件)
      processor: null, // ScriptProcessorNode (处理麦克风数据并发送给 WebSocket)

      // 转写结果
      currentTranscription: '', // 当前的语音转写结果

      // 核心修改: 静音计时器ID
      silenceTimer: null, // 用于自定义静音检测的计时器

      // 讯飞 IAT WebSocket 请求参数结构
      requestParams: {
        common: {
          app_id: '' // 应用 ID
        },
        business: {
          language: 'zh_cn', // 语种
          domain: 'iat', // 领域
          accent: 'mandarin', // 方言
          vad_eos: SILENCE_TIMEOUT, // 讯飞的静音超时设置 (毫秒)
          dwa: 'wpgs', // 动态修正
          pd: 'game', // 场景
          ptt: 0, // 不带标点符号
          rlang: 'zh-cn',
          vinfo: 1,
          nbest: 1,
          wbest: 1,
        },
        data: {
          status: 0, // 帧状态：0-开始，1-传输中，2-结束
          format: 'audio/L16;rate=16000', // 音频格式
          encoding: 'raw', // 编码
          audio: '' // 音频数据 Base64 编码
        }
      },
      hasMoved: false, // 拖动状态（用于防止拖动时触发点击）
      isVoiceTime: false, // 是否正在进行 TTS 语音播放流程
      voiceList: [
        { label: '晓晓 (女声·温柔)', value: 'Microsoft Xiaoxiao' },
        { label: '云希 (男声·清朗)', value: 'Microsoft Yunxi' },
        { label: '云扬 (男声·阳光)', value: 'Microsoft Yunyang Online' },
        { label: '晓伊 (女声·甜美)', value: 'Microsoft Xiaoyi Online' },
        { label: '云健 (男声·稳重)', value: 'Microsoft Yunjian Online' },
        { label: '云夏 (男声·热情)', value: 'Microsoft Yunxia Online' },
        { label: '晓呗 (女声·辽宁)', value: 'Microsoft Xiaobei Online' },
        { label: '晓妮 (女声·陕西)', value: 'Microsoft Xiaoni Online' }
      ]
    };
  },
  components: {
    VoiceImage
  },
  computed: {
    voiceInfo() {
      // 获取配置中的语音信息（如 TTS 文本和声音类型）
      if (this.styleTemp.overAllStyle && this.styleTemp.overAllStyle.voiceInfo && this.styleTemp.overAllStyle.voiceInfo) {
        return this.styleTemp.overAllStyle.voiceInfo
      } else {
        return {}
      }
    },
  },
  methods: {
    getVoiceType(type) {
      const result = this.voiceList.find(item => item.value === type)
      return result ? result.value : 'Microsoft Xiaoxiao'
    },
    setHasMoved(value) {
      // 设置拖动状态，防止拖动后立即触发点击事件
      this.hasMoved = value;
    },
    // 核心修改: 重置静音计时器
    resetSilenceTimer() {
      if (this.silenceTimer) {
        clearTimeout(this.silenceTimer);
      }
      // 重新设置计时器，达到 SILENCE_TIMEOUT 毫秒后自动断开录音
      this.silenceTimer = setTimeout(() => {
        console.log('2秒静音检测，自动断开。');
        // 确保在静音断开时，只有在正在录音状态下才执行
        if (this.isRecording) {
          this.stopRecording();
        }
      }, SILENCE_TIMEOUT);
    },

    // 核心修改: 检测音量是否高于阈值 (简单的 RMS 计算)
    isVoiceActivity(inputData) {
      // 简单的RMS（均方根）计算，作为音量指示
      let sumOfSquares = 0;
      for (let i = 0; i < inputData.length; i++) {
        sumOfSquares += inputData[i] * inputData[i];
      }
      const rms = Math.sqrt(sumOfSquares / inputData.length);

      // 阈值：可以根据实际环境噪音调整，0.01 是一个常见的小声阈值
      const VOICE_THRESHOLD = 0.01;

      return rms > VOICE_THRESHOLD;
    },

    // 语音转文字完成后，处理成 AI 按钮命令
    openBtn(value) {
      if (value) {
        this.isTodoBtn = true;

        // 获取用户/学校信息
        if (!this.userMsg) {
          let userMsg = localStorage.getItem("userMsg");
          if (userMsg) {
            this.userMsg = JSON.parse(userMsg);
          }
        }

        if (this.userMsg) {
          const param = {
            curpage: 1,
            pagesize: 1,
            customdeskId: this.customdeskId,
            yymsg: value, // 转写得到的语音信息
            schoolId: this.userMsg.schoolMsg.schoolId
          }
          // 调用后台接口获取对应的按钮命令
          getcommandlist(param).then(res => {
            if (res.code === 0) {
              if (res.data.buttonId) {
                // 成功找到命令，存入 localStorage 并通过 EventBus 触发
                localStorage.setItem('currentTranscription', JSON.stringify({ text: value, isAi: false }))
                console.log(EventBus,'EventBus')
                EventBus.emit('openBtn', { id: Number(res.data.buttonId), name: res.data.name });
                this.isTodoBtn = false // 命令处理结束
              } else {
                // 先走老谭的id匹配 再走郑工AI匹配
                const param = {}
                const li = []
                const voiceConfig = this.voiceInfo.voiceConfig || []
                for (const ele of voiceConfig) {
                  if (ele.children) {
                    for (const cele of ele.children) {
                      li.push(cele)
                    }
                  }
                }
                param.options = li
                param.question = value
                getoptionsbyvoice(param).then(res => {
                  if (res.data.length !== 0) {
                    localStorage.setItem('currentTranscription', JSON.stringify({ text: value, isAi: false }))
                    EventBus.emit('openBtn', { id: Number(res.data[0].id), name: res.data[0].name });
                  } else {
                    ElMessage({
                      type: 'error',
                      message: '未找到匹配的按钮'
                    })
                  }
                }).finally(() => {
                  this.isTodoBtn = false // 命令处理结束
                })
              }
            }
          })
        } else {
          this.isTodoBtn = false
        }
      }
    },

    // 核心修改: 获取麦克风访问权限 (用户阻塞步骤)
    async getMicAccess() {
      // 如果音频流已存在，直接返回成功
      if (this.audioStream) return true;

      try {
        // 请求麦克风权限，设置音频参数 (单声道, 16000 采样率, 启用回声消除和降噪)
        this.audioStream = await navigator.mediaDevices.getUserMedia({
          audio: {
            channelCount: 1,
            sampleRate: 16000,
            echoCancellation: true,
            noiseSuppression: true
          }
        });

        // 创建音频上下文，设置采样率为 16000 (与讯飞要求一致)
        this.audioContext = new (window.AudioContext || window.webkitAudioContext)({
          sampleRate: 16000
        });

        return true;
      } catch (error) {
        console.error('无法访问麦克风:', error);
        alert('无法访问麦克风，请检查权限设置');
        return false;
      }
    },

    // 核心修改: 实现点击开关功能（并行化，解决延迟）
    async toggleRecording() {
      console.log(this.hasMoved,'this.hasMoved')
      if (this.hasMoved) {
        // 如果是拖动操作，则不执行点击
        this.hasMoved = false
        return
      }
      if (this.isRecording) {
        // 状态为录音中，点击则停止
        console.log('手动点击，停止录音。');
        this.stopRecording();
      } else {
        // 状态为停止，点击则开始 TTS 语音提示流程
        this.openAiVoice()
      }
    },

    // 开始 TTS 语音提示流程
    openAiVoice() {
      // 防止重复启动
      if (this.isVoiceTime) return
      this.isVoiceTime = true
      if (this.voiceInfo.voiceBroadcast === false) {
      // if (true) {
        const audio = this.$refs.voicePlayer
        if (!audio.src) {
          audio.src = 'https://bigdata.topeti.com/wechatRepository/image/voiceBroadcast.MP3'
        }
        this.openAudio()
        return
      }
      if (this.audioChunks.length !== 0) {
        // 不用再去websocket了，重新播放音频就好了
        this.openAudio()
        return
      }
      // 准备 TTS 文本和声音参数
      let text1 = '你好，有什么可以帮助你的吗？'
      if (this.voiceInfo.avatarConfig && this.voiceInfo.avatarConfig.text1) {
        text1 = this.voiceInfo.avatarConfig && this.voiceInfo.avatarConfig.text1
      }

      // 如果 TTS 文本为空，直接跳过 TTS 流程，启动录音
      if (!text1 || text1.trim() === '') {
        this.isVoiceTime = false; // 重置状态
        this.openRecording();
        return;
      }

      const text = text1
      const voice = this.getVoiceType(this.voiceInfo.voiceType || 'Microsoft Xiaoxiao')
      const rate = 0
      const that = this

      // 构造 TTS WebSocket URL
      // const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
      const wsUrl = `wss://user.topeti.com/api/tts/stream`
      const webSocket = new WebSocket(wsUrl);

      webSocket.onopen = function () {
        console.log('TTS WebSocket连接已打开');
        // 发送 TTS 请求
        const request = {
          text: text,
          voice: voice,
          rate: rate,
          volume: 100,
        };
        webSocket.send(JSON.stringify(request));
      };

      // 接收 TTS 音频数据块
      webSocket.onmessage = (event) => {
        if (typeof event.data === 'string') {
          if(event.data.startsWith('{')){
            let fd = JSON.parse(event.data);
            if (fd.type === 'end') {
              setTimeout(() => {
                this.playAudio()
              }, 100);
            }
          }
        } else {
          if (event.data instanceof Blob) {
            event.data.arrayBuffer().then(d => {
              this.handleAudioChunk(d);
            });
          } else {
            this.handleAudioChunk(event.data);
          }
        }
      };

      webSocket.onclose = function () {
        that.isVoiceTime = false // 重置状态，无论成功与否
      };

      webSocket.onerror = function (error) {
        console.log('TTS WebSocket错误: ' + error, 'error');

        // **关键修改：TTS 发生错误时，立即启动录音，确保流程继续**
        that.isVoiceTime = false // 重置状态
      };
    },
    openAudio() {
      const audio = this.$refs.voicePlayer
      audio.play()
      audio.onended = () => {
        this.isVoiceTime = false
        this.openRecording()
      }
    },
    playAudio() {
      if (this.audioChunks.length === 0) return;

      try {
        // 合并所有音频块
        const totalLength = this.audioChunks.reduce((sum, chunk) => sum + chunk.byteLength, 0);
        const audioData = new Uint8Array(totalLength);
        let offset = 0;
        this.audioChunks.forEach(chunk => {
          audioData.set(new Uint8Array(chunk), offset);
          offset += chunk.byteLength;
        });

        // 创建Blob并播放
        const blob = new Blob([audioData], { type: 'audio/mp3' });
        const url = URL.createObjectURL(blob);

        const audio = document.getElementById('voicePlayer')
        audio.src = url;

        audio.onended = () => {
          // URL.revokeObjectURL(url)
          this.isVoiceTime = false
          this.openRecording()
        };
        audio.play().catch(error => {
          console.error('播放错误:', error);
        });
      } catch (error) {
        console.log(error,'error')
      }
    },
    handleAudioChunk(chunk) {
      if (!chunk) return;
      this.audioChunks.push(chunk);
    },

    // 启动录音前的准备工作 (获取麦克风和连接 WebSocket)
    async openRecording() {
      // --- 优化：并行启动两个阻塞操作，减少首次延迟 ---
      if (this.isConnecting) return; // 防止重复点击连接
      this.isConnecting = true;

      // 1. 立即请求麦克风权限 (用户阻塞步骤)
      const micReadyPromise = this.getMicAccess();

      // 2. 立即开始 WebSocket 连接 (网络阻塞步骤)
      const wsConnectPromise = this.connectIflytek(true);

      // 3. 等待两者都完成
      const [micReady, wsReady] = await Promise.all([micReadyPromise, wsConnectPromise]);

      this.isConnecting = false; // 无论成功与否，连接过程结束

      // 4. 如果连接和麦克风都OK，则启动数据传输
      if (wsReady && micReady) {
        this.startRecording();
      } else {
        // 如果失败，确保清理资源
        this.disconnectIflytek();
        if (this.audioStream) {
          this.audioStream.getTracks().forEach(track => track.stop());
          this.audioStream = null;
        }
        if (this.audioContext) {
          this.audioContext.close();
          this.audioContext = null;
        }
      }
    },

    // 生成讯飞 WebSocket URL（需要签名，用于认证）
    generateWebSocketUrl() {
      const host = 'iat-api.xfyun.cn';
      const path = '/v2/iat';

      const date = new Date().toUTCString(); // 当前时间 UTC 格式

      // 签名原始字符串
      const signatureOrigin = `host: ${host}\ndate: ${date}\nGET ${path} HTTP/1.1`;

      // 使用 HMAC-SHA256 和 apiSecret 进行签名
      const signatureSha = CryptoJS.HmacSHA256(signatureOrigin, this.config.apiSecret);
      const signature = CryptoJS.enc.Base64.stringify(signatureSha);

      // 构造 Authorization 字段
      const authorizationOrigin = `api_key="${this.config.apiKey}", algorithm="hmac-sha256", headers="host date request-line", signature="${signature}"`;
      const authorization = btoa(authorizationOrigin); // Base64 编码

      // 构造查询参数
      const queryParams = {
        host,
        date,
        authorization
      };

      // 拼接成 URL 查询字符串
      const queryString = Object.keys(queryParams)
        .map(key => `${key}=${encodeURIComponent(queryParams[key])}`)
        .join('&');

      // 最终的 WebSocket URL
      return `wss://${host}${path}?${queryString}`;
    },

    // 核心修改: 连接讯飞WebSocket服务 (返回 Promise)
    connectIflytek(isInitial = false) {
      // 检查配置是否完整
      if (!this.config.appId || !this.config.apiKey || !this.config.apiSecret) {
        alert('请先填写完整的讯飞API配置信息');
        return Promise.resolve(false);
      }

      return new Promise(resolve => {
        try {
          this.wsUrl = this.generateWebSocketUrl(); // 生成签名 URL
          this.ws = new WebSocket(this.wsUrl); // 创建 WebSocket 实例

          // 设置请求参数
          this.requestParams.common.app_id = this.config.appId;
          this.requestParams.business.language = this.config.language;
          this.requestParams.business.vad_eos = SILENCE_TIMEOUT;

          // WebSocket 连接成功
          this.ws.onopen = () => {
            console.log('WebSocket连接已建立');
            this.isConnected = true;

            // 发送 start frame (状态 0)
            const startFrame = {
              common: this.requestParams.common,
              business: this.requestParams.business,
              data: {
                status: 0,
                format: 'audio/L16;rate=16000',
                encoding: 'raw',
                audio: ''
              }
            };
            this.ws.send(JSON.stringify(startFrame));

            if (isInitial) resolve(true); // 通知 openRecording 连接已完成
          };

          // 接收到讯飞的转写结果
          this.ws.onmessage = (event) => {
            this.handleWebSocketMessage(event);
          };

          // WebSocket 发生错误
          this.ws.onerror = (error) => {
            console.error('WebSocket错误:', error);
            this.isConnected = false;
            if (isInitial) resolve(false);
          };

          // WebSocket 连接关闭
          this.ws.onclose = () => {
            console.log('WebSocket连接已关闭');
            this.isConnected = false;
            this.isRecording = false;
            // 清理静音计时器
            if (this.silenceTimer) {
              clearTimeout(this.silenceTimer);
              this.silenceTimer = null;
            }
          };

        } catch (error) {
          console.error('连接失败:', error);
          alert('连接失败: ' + error.message);
          if (isInitial) resolve(false);
        }
      });
    },

    // 处理讯飞 WebSocket 消息（转写结果）
    handleWebSocketMessage(event) {
      try {
        const response = JSON.parse(event.data);

        if (response.code !== 0) {
          console.error('讯飞API返回错误:', response);
          return;
        }

        if (response.data && response.data.result) {
          const result = response.data.result;
          const transcribeText = this.parseTranscribeResult(result);

          if (transcribeText) {
            // 如果是中间结果 (status === 1)
            if (response.data.status === 1) {
              this.currentTranscription = transcribeText;
            }
          }
        }

        // 核心修改：处理最终结果 (status === 2)，这是讯飞自带的 VAD/静音断开
        if (response.data && response.data.status === 2) {
          console.log('讯飞 VAD/静音检测，转写结束');
          this.stopRecording(); // 收到最终帧，手动停止本地录音流程
        }

      } catch (error) {
        console.error('解析响应数据失败:', error);
      }
    },

    // 解析讯飞转写结果的 JSON 结构
    parseTranscribeResult(result) {
      try {
        let text = '';
        const ws = result.ws; // 词语数组 (words)

        for (let i = 0; i < ws.length; i++) {
          const cw = ws[i].cw; // 候选词数组 (candidates)
          for (let j = 0; j < cw.length; j++) {
            text += cw[j].w; // 拼接文本
          }
        }

        return text;
      } catch (error) {
        console.error('解析转写结果失败:', error);
        return '';
      }
    },

    // 核心修改: 启动数据传输（假设麦克风和 WS 都已就绪）
    startRecording() {
      if (!this.isConnected || !this.audioStream) {
        console.error('无法启动录音: WS或麦克风未就绪');
        return;
      }

      // 创建媒体流源 (从麦克风获取数据)
      const source = this.audioContext.createMediaStreamSource(this.audioStream);

      // 创建分析器用于音频可视化 (传递给 VoiceImage 组件)
      this.analyser = this.audioContext.createAnalyser();
      this.analyser.fftSize = 256;
      source.connect(this.analyser);

      // 创建脚本处理器 (用于获取和处理音频数据)
      // 缓冲区大小 4096，输入通道 1，输出通道 1
      this.processor = this.audioContext.createScriptProcessor(4096, 1, 1);
      source.connect(this.processor); // 将麦克风源连接到处理器
      this.processor.connect(this.audioContext.destination); // 连接到目标 (保证音频流持续)

      // 核心：音频数据处理事件
      this.processor.onaudioprocess = (event) => {
        // 只有在录音中且 WebSocket 开启时才发送数据
        if (this.isRecording && this.ws && this.ws.readyState === WebSocket.OPEN) {
          const inputData = event.inputBuffer.getChannelData(0); // 获取浮点型音频数据

          // 检测音量，如果有声音则重置计时器 (自定义 VAD 逻辑)
          if (this.isVoiceActivity(inputData)) {
            this.resetSilenceTimer();
          }

          // 数据格式转换：浮点型转 16 位 PCM 整数
          const int16Data = this.floatTo16BitPCM(inputData);
          // 转换为 Base64 编码
          const base64Data = this.arrayBufferToBase64(int16Data.buffer);

          // 构造数据帧 (状态 1)
          const audioFrame = {
            data: {
              status: 1, // 传输中
              format: 'audio/L16;rate=16000',
              encoding: 'raw',
              audio: base64Data
            }
          };

          // 发送音频数据
          this.ws.send(JSON.stringify(audioFrame));
        }
      };

      this.isRecording = true;
      this.resetSilenceTimer(); // 开始录音时启动自定义静音计时器
      console.log('录音数据传输开始');
    },

    // 停止录音
    stopRecording() {
      if (!this.isRecording) return;

      // 清理静音计时器
      if (this.silenceTimer) {
        clearTimeout(this.silenceTimer);
        this.silenceTimer = null;
      }

      // 发送结束帧 (状态 2)
      if (this.ws && this.ws.readyState === WebSocket.OPEN) {
        const endFrame = {
          data: {
            status: 2, // 结束
            format: 'audio/L16;rate=16000',
            encoding: 'raw',
            audio: ''
          }
        };

        this.ws.send(JSON.stringify(endFrame));
      }

      // 断开 ScriptProcessorNode 和音频流
      if (this.processor && this.audioContext) {
        this.processor.disconnect();
        this.processor.onaudioprocess = null;
        this.processor = null;
      }

      // 停止麦克风轨道，释放麦克风资源
      if (this.audioStream) {
        this.audioStream.getTracks().forEach(track => track.stop());
        this.audioStream = null;
      }

      // 关闭音频上下文
      if (this.audioContext) {
        this.audioContext.close();
        this.audioContext = null;
      }

      this.isRecording = false;
      this.isVoiceTime = false // TTS 流程结束
      this.disconnectIflytek() // 断开讯飞 WebSocket 连接

      // 处理最终的转写结果（例如：执行命令）
      this.openBtn(this.currentTranscription)
      this.currentTranscription = ''; // 清空当前转写结果

      console.log('停止录音');
    },

    // 断开讯飞 WebSocket 连接
    disconnectIflytek() {
      if (this.ws) {
        this.ws.close();
        this.ws = null;
      }

      this.isConnected = false;
      this.isRecording = false;
    },

    // 工具函数：浮点音频数据 (-1.0 到 1.0) 转 16 位 PCM 整数 (-32768 到 32767)
    floatTo16BitPCM(input) {
      const output = new Int16Array(input.length);
      for (let i = 0; i < input.length; i++) {
        const s = Math.max(-1, Math.min(1, input[i])); // 钳制在 [-1, 1]
        // 转换为 16 位整数范围
        output[i] = s < 0 ? s * 0x8000 : s * 0x7FFF;
      }
      return output;
    },

    // 工具函数：ArrayBuffer (二进制数据) 转 Base64 字符串
    arrayBufferToBase64(buffer) {
      let binary = '';
      const bytes = new Uint8Array(buffer);
      const len = bytes.byteLength;
      for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      // 使用浏览器自带的 btoa 函数进行 Base64 编码
      return window.btoa(binary);
    },
  },

  // 组件销毁时清理资源
  beforeUnmount() {
    this.disconnectIflytek();
    if (this.silenceTimer) {
      clearTimeout(this.silenceTimer);
      this.silenceTimer = null;
    }
  }
}
</script>

<style scoped>
.voice-to-text-container {
  height: 0;
}
</style>